/**
 * countdown-timer.js
 * Hydrates all [.countdown-timer] elements.
 * Each element has a data-end-time attribute (ISO date string).
 * Falls back to midnight IST if no end time is set.
 * Resets and loops on expiry.
 */

(function () {
  'use strict';

  document.querySelectorAll('.countdown-timer').forEach(initTimer);

  function initTimer(el) {
    const hoursEl = el.querySelector('[data-countdown-hours]');
    const minutesEl = el.querySelector('[data-countdown-minutes]');
    const secondsEl = el.querySelector('[data-countdown-seconds]');

    if (!hoursEl || !minutesEl || !secondsEl) return;

    let endTime = getEndTime(el.dataset.endTime);

    function tick() {
      const now = Date.now();
      let remaining = endTime - now;

      if (remaining <= 0) {
        // Reset to next midnight IST
        endTime = getNextMidnightIST();
        remaining = endTime - now;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    tick(); // Immediate first render
    const interval = setInterval(tick, 1000);

    // Cleanup if element is removed
    const mo = new MutationObserver(() => {
      if (!document.contains(el)) {
        clearInterval(interval);
        mo.disconnect();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function getEndTime(isoString) {
    if (isoString) {
      const parsed = new Date(isoString).getTime();
      if (!isNaN(parsed) && parsed > Date.now()) return parsed;
    }
    return getNextMidnightIST();
  }

  function getNextMidnightIST() {
    // IST = UTC+5:30
    const now = new Date();
    const ist = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
    ist.setHours(23, 59, 59, 0);
    // Convert back to UTC ms
    const diff = now.getTime() - new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' })).getTime();
    return ist.getTime() + diff;
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }
})();
